import { IconComponent } from './types';

const DegreeIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.51522 10L0 0.470635L0.484781 0L8 9.52936L7.51522 10Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 12H4.33436e-07L4.33436e-07 0L0.699029 0L0.699029 11.301H12V12Z"
      fill="currentColor"
    />
  </svg>
);

export default DegreeIcon;
